module.exports = __webpack_public_path__ + "static/media/biteship-label.e1e07880.png";